import styled from '@emotion/styled'
import React from 'react'
import { createPropFilter } from '@news-mono/web-common'
import { calcRem, colors, themedValue } from '../__styling'

export const StyledWrapper = styled('div')({
    position: 'relative',
    width: '100%',
})

export const StyledScroll = styled('div')({
    display: 'flex',
    gap: calcRem(12),
    overflowX: 'auto',
    scrollBehavior: 'smooth',
    padding: `${calcRem(8)} 0`,
    scrollbarWidth: 'none',

    '&::-webkit-scrollbar': {
        display: 'none',
    },

    '&[data-disable-drag="true"]': {
        overflowX: 'hidden',
        scrollBehavior: 'auto',
    },
})

interface StyledButtonProps
    extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string
}

export const StyledButtonBase = styled('button', {
    shouldForwardProp: createPropFilter<StyledButtonProps>()(['className']),
})<StyledButtonProps>(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 5,
    width: themedValue(theme, {
        perthnow: calcRem(42),
        thewest: calcRem(42),
        fallback: calcRem(32),
    }),
    height: themedValue(theme, {
        perthnow: calcRem(42),
        thewest: calcRem(42),
        fallback: calcRem(32),
    }),
    borderRadius: themedValue(theme, {
        sevennews: '50%',
        thenightly: '50%',
        perthnow: calcRem(8),
        fallback: 0,
    }),
    border: 'none',
    cursor: 'pointer',
    background: themedValue(theme, {
        thewest: colors.thewest.westblue,
        perthnow: colors.perthnow.pinkThulite,
        fallback: colors.white,
    }),
    color: colors.black,
    marginHorizontal: calcRem(8),
    textAlign: 'center',

    '&:disabled': {
        opacity: 0.3,
        cursor: 'default',
    },

    svg: {
        marginTop: calcRem(3),
    },
}))

export const StyledButtonLeft = styled(StyledButtonBase)({
    left: calcRem(10),

    svg: {
        marginLeft: calcRem(8),
        rotate: '180deg',
    },
})

export const StyledButtonRight = styled(StyledButtonBase)({
    right: calcRem(10),

    svg: {
        marginRight: calcRem(8),
    },
})
